import { useEffect, useRef } from "react";
import { ArrowRight } from "lucide-react";
import logo from "../assets/carioprint-logo.png";
import "./LoginEntrance.css";

// The timer is independent of CSS animation events, so a disabled animation cannot trap a session.
export const ENTRANCE_DURATION_MS = 2900;

export default function LoginEntrance({ name, onComplete, slow = false }: { name: string; onComplete: () => void; slow?: boolean }) {
  const skip = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    skip.current?.focus({ preventScroll: true });
    const motion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const finishIfReduced = () => { if (motion.matches) onComplete(); };
    finishIfReduced();
    motion.addEventListener("change", finishIfReduced);
    const timer = window.setTimeout(onComplete, ENTRANCE_DURATION_MS * (slow ? 2 : 1));
    return () => {
      window.clearTimeout(timer);
      motion.removeEventListener("change", finishIfReduced);
    };
  }, [onComplete, slow]);

  return <main className={`cario-entrance${slow ? ' ce-slow' : ''}`} aria-label="Bienvenida a CarioPrint" onKeyDown={event => {
    if (event.key === "Escape") onComplete();
  }}>
    <div className="ce-aurora" aria-hidden="true" />
    <div className="ce-grid" aria-hidden="true" />
    <header className="ce-top"><span>CARIOPRINT <i /> ESTUDIO EN MOVIMIENTO</span><span className="ce-session">{slow ? 'Pantalla TV' : 'Sesión iniciada'}</span></header>
    <div className="ce-scene" aria-hidden="true">
      <div className="ce-glass ce-glass-left" /><div className="ce-glass ce-glass-right" />
      <div className="ce-machine">
        <div className="ce-machine-top"><span>CARIO / PRESS</span><span className="ce-led" /></div>
        <div className="ce-slot" />
        <div className="ce-paper-window">
          <div className="ce-paper">
            <div className="ce-paper-meta"><span>EDICIÓN DE HOY</span><span>01 / 01</span></div>
            <div className="ce-logo"><img src={logo} alt="" /><div className="ce-print-beam" /></div>
            <div className="ce-paper-rule" />
            <p>Las grandes ideas<br /><strong>empiezan contigo.</strong></p>
            <div className="ce-paper-footer"><span className="ce-inks"><i /><i /><i /><i /></span><span>CREAR · CONECTAR · PRODUCIR</span></div>
          </div>
        </div>
        <div className="ce-machine-lip"><span /><span /><span /></div>
      </div>
      <div className="ce-orbit" />
    </div>
    <section className="ce-copy">
      <p className="ce-kicker">TU PRÓXIMA GRAN IMPRESIÓN</p>
      <h1>Todo toma forma.</h1>
      <p role="status">Bienvenido, {name}. Tu espacio está listo.</p>
      <div className="ce-phases" aria-hidden="true"><span>01 <b>Conectar</b></span><i /><span>02 <b>Imprimir</b></span><i /><span>03 <b>Crear</b></span></div>
    </section>
    <button className="ce-skip" ref={skip} onClick={onComplete}>Ir a mi espacio <ArrowRight size={16} aria-hidden="true" /></button>
  </main>;
}
